import { render, staticRenderFns } from "./AssetApprovalForm.vue?vue&type=template&id=2ca3362d&"
import script from "./AssetApprovalForm.vue?vue&type=script&lang=js&"
export * from "./AssetApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetApprovalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports